import { Routes, Route } from 'react-router-dom'
import Home from '@pages/Home'
import Player from '@pages/Player'
import Login from '@pages/Login'
import Register from '@pages/Register'
import ForgotPassword from '@pages/ForgotPassword'
import ResetPassword from '@pages/ResetPassword'
import Profile from '@pages/Profile'
import VIP from '@pages/VIP'
import Redeem from '@pages/Redeem'
import AdminLogin from '@pages/Admin/AdminLogin'
import AdminDashboard from '@pages/Admin/Dashboard'

function App() {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/player" element={<Player />} />
            <Route path="/player.html" element={<Player />} />
            <Route path="/login" element={<Login />} />
            <Route path="/login.html" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/register.html" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/forgot-password.html" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/reset-password.html" element={<ResetPassword />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/profile.html" element={<Profile />} />
            <Route path="/vip" element={<VIP />} />
            <Route path="/vip.html" element={<VIP />} />
            <Route path="/redeem" element={<Redeem />} />
            <Route path="/redeem.html" element={<Redeem />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/admin-login.html" element={<AdminLogin />} />
            <Route path="/dinoadmin" element={<AdminDashboard />} />
            <Route path="/dinoadmin.html" element={<AdminDashboard />} />
        </Routes>
    )
}

export default App
